import {
  BackgroundAlignIcon,
  BackgroundAlignIconAlt,
} from '@src/svgs/BackgroundAlignIcon';
import { Tooltip } from 'react-tooltip';
import styled from 'styled-components';

import { COMPACT_TOOLTIP_STYLE } from '../../common/tooltipStyles';

import type { KaraokeConfig } from '@src/services/karaoke/karaokeTypes';

type Props = {
  backgroundAlignThreshold?: string;
  action: (propertyMap: Partial<KaraokeConfig>) => void;
  tooltipId?: string;
};

// Standalone align-threshold toggle with tooltip. Keeps behavior consistent
// with the inline implementation in KaraokeBackground.
const AlignThresholdControl = (props: Props) => {
  const {
    backgroundAlignThreshold,
    action,
    tooltipId = 'background-align-tooltip',
  } = props;

  const isActive = backgroundAlignThreshold === '100%';

  return (
    <Wrapper>
      <Button
        isActive={isActive}
        onClick={() => {
          action({
            background_align_threshold: isActive ? '0%' : '100%',
          });
        }}
        data-tooltip-id={tooltipId}
        data-tooltip-content={isActive ? 'Line Filled' : 'Line Cropped'}
      >
        {isActive ? <BackgroundAlignIcon /> : <BackgroundAlignIconAlt />}
      </Button>
      <Tooltip
        id={tooltipId}
        style={COMPACT_TOOLTIP_STYLE}
        place="top"
        positionStrategy="fixed"
      />
    </Wrapper>
  );
};

export default AlignThresholdControl;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Button = styled.button<{ isActive: boolean }>`
  width: 42px;
  height: 42px;
  aspect-ratio: 1/1;
  border: 1px solid
    ${props => (props.isActive ? 'var(--accent)' : 'var(--border)')};
  background-color: ${props =>
    props.isActive ? 'var(--accent)' : 'var(--background)'};
  border-radius: var(--radius);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 0;
`;
